import React, { FC, useCallback } from 'react';
import styles from './MediaUpload.scss';
import { AddItem, IconButton, Image } from '@wix/design-system';
import { useFilePicker } from '@wix/gg-common-lib/hooks';
import { X } from '@wix/wix-ui-icons-common';

type Props = {
  onFilePicked: (file: File | undefined) => void;
  onRemoveClicked?: () => void;
  imageUrl?: string;
};

export const MediaUpload: FC<Props> = ({ onFilePicked, onRemoveClicked, imageUrl }) => {
  const { openFilePicker } = useFilePicker({ onFilePicked });

  const renderContent = useCallback(() => {
    if (imageUrl) {
      return <Image src={imageUrl} width="100%" height="100%" />;
    }
    return <AddItem skin="image" onClick={openFilePicker} />;
  }, [imageUrl, openFilePicker]);

  return (
    <div className={styles.mediaUpload}>
      {imageUrl && (
        <div className={styles.mediaUploadFloater}>
          <IconButton onClick={onRemoveClicked} skin="light" size="tiny">
            <X />
          </IconButton>
        </div>
      )}
      {renderContent()}
    </div>
  );
};
